var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInviteNewUserSuccess = function SvgInviteNewUserSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 366 331",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M264.41 47.4795C309.887 79.618 340.495 124.287 355.213 163.232C369.933 202.705 368.756 236.439 350.831 258.952C332.731 281.684 300.536 291.085 262.209 295.076C223.905 298.552 179.475 296.628 137.653 284.793C54.9408 263.909 8.54681 188.763 36.6896 99.7529C64.4263 11.115 172.774 -20.5614 264.41 47.4795Z",
    fill: "#FFD763"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.48 301.197C135.48 315.99 123.5 327.988 108.698 327.988C93.9044 327.988 81.9092 315.99 81.9092 301.197C81.9092 286.415 93.9044 274.414 108.698 274.414C123.5 274.414 135.48 286.415 135.48 301.197Z",
    fill: "#EAF4FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.409 304.139C238.375 300.075 239.51 295.524 239.51 290.708C239.51 273.624 225.655 259.766 208.563 259.766C191.479 259.766 177.612 273.624 177.612 290.708C177.612 295.524 178.745 300.075 180.721 304.139H236.409Z",
    fill: "#EAF4FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.331 125.488L167.963 188.612L181.598 305.507H127.075L140.707 188.612L154.331 125.488Z",
    fill: "#C5E1F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.365 125.488L163.866 188.612L173.365 305.507H135.376L144.875 188.612L154.365 125.488Z",
    fill: "#EAF4FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.307 125.488L157.125 188.612L159.933 305.507H148.682L151.499 188.612L154.307 125.488Z",
    fill: "#C5E1F9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.203 305.815C221.327 304.775 221.406 303.713 221.406 302.633C221.406 287.847 209.425 275.853 194.624 275.853C190.445 275.853 186.5 276.837 182.968 278.552C178.901 264.596 166.033 254.395 150.761 254.395C134.07 254.395 120.27 266.581 117.659 282.522C109.082 284.027 101.529 288.549 96.2044 294.99C94.4501 294.42 92.5687 294.103 90.6125 294.103C80.6198 294.103 72.5098 302.207 72.5098 312.205C72.5098 322.078 80.4167 330.088 90.2431 330.288L90.2538 330.304H219.778L219.812 330.205C220.157 330.227 220.475 330.304 220.822 330.304C227.603 330.304 233.085 324.815 233.085 318.043C233.085 311.402 227.799 306.018 221.203 305.815Z",
    fill: "#C5E1F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.465 262.315C115.184 262.315 111.184 263.556 107.797 265.674C107.628 247.283 92.6799 232.422 74.2482 232.422C59.7765 232.422 47.4939 241.579 42.7642 254.393C39.195 253.093 35.3537 252.348 31.3332 252.348C17.0159 252.348 4.84726 261.3 0 273.888C2.97178 276.173 6.65028 277.577 10.6673 277.656L10.6697 277.668H140.202L140.234 277.571L140.465 277.594C137.601 268.732 129.293 262.315 119.465 262.315Z",
    fill: "#EAF4FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M252.223 308.797C252.953 306.514 253.314 304.073 253.191 301.537C252.659 290.084 242.934 281.227 231.468 281.761C220.011 282.3 211.155 292.029 211.693 303.489C211.813 306.024 212.396 308.418 213.336 310.624L252.223 308.797Z",
    fill: "#C5E1F9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.971 269.057C101.971 281.202 92.1221 291.048 79.9724 291.048C67.8311 291.048 57.9834 281.202 57.9834 269.057C57.9834 256.917 67.8311 247.07 79.9724 247.07C92.1221 247.07 101.971 256.917 101.971 269.057Z",
    fill: "#C5E1F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M155.758 151.855C144.571 151.855 135.498 166.922 135.498 185.502C135.498 187.86 135.645 190.163 135.924 192.378H175.59C175.87 190.163 176.015 187.86 176.015 185.502C176.015 166.922 166.952 151.855 155.758 151.855Z",
    fill: "#0450CF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.49 151.855C142.215 151.855 135.498 166.922 135.498 185.502C135.498 187.86 135.609 190.163 135.813 192.378H165.155C165.358 190.163 165.47 187.86 165.47 185.502C165.47 166.922 158.756 151.855 150.49 151.855Z",
    fill: "#0561FC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.942 73.9011C136.942 109.751 118.573 140.948 91.4726 157.112C90.6625 157.869 89.862 158.608 89.0816 159.321C84.0728 163.891 85.7024 185.491 85.7024 185.491H137.201V60.5471C137.201 62.4796 137.032 64.9181 136.737 67.7188C136.852 69.7665 136.942 71.8214 136.942 73.9011Z",
    fill: "#4A62C7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M137.22 115.723C129.011 136.639 113.503 153.976 93.7693 164.696C92.8737 165.455 92.0019 166.196 91.1491 166.91C87.7972 169.694 87.157 178.788 87.1582 185.478H137.22V115.723Z",
    fill: "#EAF4FE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7314 183.352C90.9296 183.941 90.2681 184.819 89.7217 185.884H137.265V144.531C127.279 159.897 112.515 172.617 94.7043 181.145C93.6924 181.902 92.6994 182.64 91.7314 183.352Z",
    fill: "#C5E1F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M175.194 73.9011C175.194 109.751 193.552 140.948 220.663 157.112C221.468 157.869 222.266 158.608 223.049 159.321C228.055 163.891 226.422 185.491 226.422 185.491H174.927V60.5471C174.927 62.4796 175.088 64.9181 175.39 67.7188C175.274 69.7665 175.194 71.8214 175.194 73.9011Z",
    fill: "#4A62C7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M174.927 115.723C183.141 136.639 198.636 153.976 218.379 164.696C219.267 165.455 220.154 166.196 221.001 166.91C224.352 169.694 224.996 178.788 224.983 185.478H174.927V115.723Z",
    fill: "#EAF4FE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M220.469 183.352C221.265 183.941 221.923 184.819 222.479 185.884H174.927V144.531C184.922 159.897 199.682 172.617 217.489 181.145C218.496 181.902 219.498 182.64 220.469 183.352Z",
    fill: "#C5E1F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M176.23 185.665V56.4995C176.23 44.6777 167.441 6.31771 156.044 0C144.655 6.31771 135.864 44.6777 135.864 56.4995V185.665H176.23Z",
    fill: "#C5E1F9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.11 0C156 0.0629514 155.891 0.149662 155.762 0.223304V185.665H176.296V56.4995C176.296 44.6777 167.506 6.31771 156.11 0Z",
    fill: "#EAF4FE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M141.724 26.3766H170.562C166.947 14.4444 161.873 3.1737 156.144 0C150.416 3.1737 145.357 14.4444 141.724 26.3766Z",
    fill: "#4A62C7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M155.762 26.3766H170.528C166.912 14.4444 161.838 3.1737 156.11 0C156 0.0629514 155.891 0.149662 155.762 0.223303V26.3766Z",
    fill: "#4A62C7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M168.566 47.8483C167.733 49.7368 164.993 49.0253 161.77 47.8209C158.087 46.3778 153.977 46.3778 150.294 47.8209C147.08 49.0182 144.329 49.7368 143.506 47.8483C142.646 46.0084 144.657 41.5507 148.849 39.9283C153.46 38.1229 158.614 38.1229 163.228 39.9283C167.413 41.5377 169.416 45.9989 168.566 47.8483Z",
    fill: "#0561FC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.94 154.785C110.05 154.785 106.079 169.852 106.079 188.432C106.079 190.79 106.146 193.093 106.26 195.308H123.629C123.751 193.093 123.81 190.79 123.81 188.432C123.81 169.852 119.844 154.785 114.94 154.785Z",
    fill: "#4A62C7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M114.906 154.785C113.625 154.785 112.424 155.833 111.328 157.675C115.349 159.875 118.442 172.979 118.442 188.864C118.442 191.075 118.388 193.227 118.273 195.308H123.595C123.716 193.093 123.776 190.79 123.776 188.432C123.776 169.852 119.81 154.785 114.906 154.785Z",
    fill: "#4A62C7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M197.214 154.785C192.326 154.785 188.354 169.852 188.354 188.432C188.354 190.79 188.415 193.093 188.535 195.308H205.894C206.017 193.093 206.074 190.79 206.074 188.432C206.074 169.852 202.112 154.785 197.214 154.785Z",
    fill: "#4A62C7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M197.307 154.785C196.036 154.785 194.821 155.833 193.726 157.675C197.747 159.875 200.844 172.979 200.844 188.864C200.844 191.075 200.789 193.227 200.669 195.308H205.987C206.109 193.093 206.166 190.79 206.166 188.432C206.166 169.852 202.205 154.785 197.307 154.785Z",
    fill: "#4A62C7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M274.773 318.39L274.04 322.742L269.621 322.836C269.621 322.836 266.307 322.907 265.479 322.923C264.649 322.943 259.674 323.048 259.674 323.048L259.644 321.456C259.644 321.456 266.497 318.92 267.821 316.239C269.147 313.56 274.773 318.39 274.773 318.39Z",
    fill: "#00046D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M319.659 322.216L319.618 324.303L308.016 324.059L307.861 318.444L314.862 318.36C314.862 318.36 318.563 321.893 319.659 322.216Z",
    fill: "#00046D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M337.303 88.2393C337.303 88.2393 337.947 75.9709 337.355 75.9507C336.813 75.9329 336.512 76.7524 336.512 76.7524L335.828 80.1934L336.153 72.7247C336.153 72.7247 335.558 72.2959 335.094 72.7984C334.866 73.0466 334.744 73.4991 334.68 73.8531L334.384 71.8161C334.384 71.8161 334.4 71.5239 333.873 71.4823C333.319 71.4419 333.035 72.2864 333.035 72.2864L332.199 79.217L330.803 71.6545C330.803 71.6545 330.29 70.8682 329.696 71.6023C329.497 71.86 329.681 72.9599 329.681 72.9599L329.852 74.8888L330.126 79.185L329.736 82.5891C329.736 82.5891 329.884 84.322 327.901 80.9654C326.777 79.0519 325.774 80.0449 325.774 80.0449L326.258 81.4239C326.258 81.4239 327.866 85.0976 328.625 86.5135C329.249 87.6846 333.275 89.2453 334.658 89.7572L316.106 129.573C316.106 129.573 312.166 142.369 328.077 136.002C341.27 130.72 338.093 100.272 336.621 90.0399L337.303 88.2393Z",
    fill: "#F7B68B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M320.566 162.334L329.82 139.937C329.82 139.937 320.111 126.031 317.076 124.516C316.543 124.246 306.613 137.122 300.447 143.291C293.573 150.163 317.076 153.482 320.566 162.334Z",
    fill: "#E91171"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313.118 204.691C313.118 205.698 290.785 262.053 290.785 262.053L275.681 317.749H265.625L275.904 259.639L285.157 204.102L313.118 204.691Z",
    fill: "#7038A7"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M302.079 217.003C303.291 220.623 307.101 265.028 307.101 265.028L306.887 320.326H317.347L320.382 265.831L328.232 204.59L298.462 207.98L302.079 217.003Z",
    fill: "#7038A7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M292.681 142.521C292.681 142.521 279.201 150.569 274.374 155.399C269.546 160.227 276.388 151.174 279.806 173.101C283.228 195.028 279.916 216.316 280.522 216.516C281.127 216.717 330.501 206.296 330.501 206.296C330.501 206.296 325.338 153.074 320.644 146.548C317.56 142.254 313.2 141.114 313.2 141.114C313.2 141.114 300.325 141.114 292.681 142.521Z",
    fill: "#E91171"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M298.482 198.521C297.992 198.521 297.662 196.947 297.741 196.504L302.492 167.94C302.572 167.496 303.03 165.528 303.517 165.528H319.856C320.346 165.528 320.678 166.891 320.595 167.334L315.844 196.004C315.767 196.449 315.306 198.521 314.814 198.521H298.482Z",
    fill: "#8331D3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M265.882 177.769C265.882 177.769 260.851 188.029 261.253 196.881C261.656 205.732 290.064 204.001 297.063 200.501C299.074 199.495 303.101 198.892 303.101 198.892L307.529 194.063L308.934 191.047C308.934 191.047 307.823 187.481 306.916 188.231C303.405 191.148 299.781 193.862 298.972 193.763C298.318 193.681 298.371 191.653 298.168 191.248C297.36 189.638 296.358 191.754 295.655 196.077C295.387 197.713 284.792 192.254 276.944 191.851C276.121 191.809 279.158 180.585 279.158 180.585C279.158 180.585 271.51 177.369 265.882 177.769Z",
    fill: "#F7B68B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M272.512 157.227C272.512 157.227 261.242 174.93 262.853 175.735C264.463 176.54 273.315 183.179 278.142 187.202C282.964 191.225 283.173 162.055 272.512 157.227Z",
    fill: "#E91171"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M295.506 153.076C299.764 153.49 303.798 149.769 306.024 144.052C302.939 142.588 300.076 139.381 299.946 135.012C299.749 128.233 292.172 134.415 292.172 134.415C292.172 134.415 294.364 141.792 291.575 144.188C289.367 146.077 292.051 152.74 295.506 153.076Z",
    fill: "#F7B68B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M285.89 126.941C285.89 126.941 275.519 124.415 278.308 118.034C281.1 111.65 281.368 115.774 281.502 113.115C281.628 110.454 280.168 104.471 283.76 105.268C287.35 106.068 290.005 105.8 293.734 103.673C297.453 101.548 299.316 100.083 300.517 104.071C301.711 108.062 301.577 107.53 305.829 107.929C310.087 108.327 311.283 109.125 309.823 111.385C308.357 113.647 306.233 114.445 308.223 116.704C310.22 118.963 310.621 121.225 309.025 122.82C307.426 124.415 300.316 127.406 300.316 127.406L285.89 126.941Z",
    fill: "#7038A7"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M301.919 122.282C301.919 122.282 305.287 120.05 306.084 121.703C306.886 123.358 306.506 126.236 305.24 127.642C303.974 129.05 302.469 131.005 301.493 127.753C300.517 124.497 301.919 122.282 301.919 122.282Z",
    fill: "#EC9568"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M283.576 128.373C283.576 128.373 282.007 124.136 285.309 124.539C287.138 124.761 289.367 126.604 289.885 128.425C290.397 130.245 291.246 132.561 287.974 131.65C284.705 130.739 283.576 128.373 283.576 128.373Z",
    fill: "#EC9568"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M300.44 138.045C300.105 137.11 299.902 136.098 299.871 135.012C299.674 128.233 292.097 134.415 292.097 134.415C292.097 134.415 294.289 141.792 291.5 144.188C291.366 144.299 291.246 144.404 291.138 144.5C295.297 144.024 298.787 141.508 300.44 138.045Z",
    fill: "#EC9568"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M284.912 124.195C284.912 124.195 287.462 133.51 291.899 136.961C294.886 139.289 299.411 137.426 302.071 132.508C304.675 127.69 303.667 111.034 298.482 113.627C293.293 116.218 297.681 110.236 294.886 112.232C292.099 114.225 296.685 122.002 284.912 124.195Z",
    fill: "#F7B68B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M294.046 125.536H293.635C293.631 127.492 292.047 129.077 290.09 129.08C288.134 129.077 286.547 127.492 286.544 125.536C286.547 123.579 288.134 121.997 290.09 121.993C292.047 121.997 293.631 123.579 293.635 125.536H294.046C294.046 123.352 292.275 121.582 290.09 121.582C287.907 121.582 286.133 123.351 286.133 125.536C286.133 127.72 287.907 129.491 290.09 129.491C292.275 129.491 294.046 127.72 294.046 125.536Z",
    fill: "#212A54"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M302.464 124.072H302.052C302.048 126.03 300.467 127.615 298.505 127.619C296.553 127.615 294.971 126.03 294.968 124.072C294.971 122.115 296.553 120.531 298.505 120.528C300.467 120.531 302.048 122.115 302.052 124.072H302.464C302.464 121.888 300.695 120.117 298.505 120.117C296.325 120.117 294.557 121.888 294.556 124.072C294.557 126.256 296.325 128.03 298.505 128.03C300.695 128.03 302.464 126.256 302.464 124.072Z",
    fill: "#212A54"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M293.644 125.229L295.605 124.918L295.541 124.512L293.579 124.823",
    fill: "#212A54"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M293.945 133.574C293.96 133.579 294.31 133.68 294.871 133.681C296.1 133.687 298.353 133.167 300.163 130.092L299.809 129.883C298.056 132.839 295.992 133.263 294.871 133.269C294.615 133.269 294.41 133.247 294.27 133.223L294.11 133.192L294.062 133.18L293.945 133.574Z",
    fill: "#212A54"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M232.971 268.283C233.242 274.057 228.781 278.962 222.991 279.232C217.225 279.504 212.31 275.042 212.049 269.262C211.769 263.484 216.239 258.581 222.011 258.313C227.796 258.041 232.701 262.502 232.971 268.283Z",
    fill: "#C5E1F9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 68.8308,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 40.6123,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.611,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 40.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.169,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 40.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.251,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 40.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.891,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 40.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 239.53,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.832,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.831,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.831,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.831,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.831,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 68.8305,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 74.4702,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 80.1096,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 85.7492,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 91.3886,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.832,
    cy: 40.6118,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.831,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.831,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.831,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.831,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 40.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 273.389,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 40.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.471,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 40.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.11,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 40.6113,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 46.2507,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 51.8901,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 57.5297,
    r: 1.61129,
    fill: "#7038A7"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.749,
    cy: 63.1694,
    r: 1.61129,
    fill: "#7038A7"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInviteNewUserSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invite-new-user-success.e43faaa4.svg";
export { ForwardRef as ReactComponent };